import React from "react";
import { Box, Typography, Container, Stack } from "@mui/material";

// terms-and-conditions.tsx
// Route example: <Route path="/terms" element={<TermsAndConditions />} />

export default function TermsAndConditions() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
        Terms and Conditions
      </Typography>

      <Stack spacing={4}>
        {/* Intro */}
        <Box>
          <Typography variant="body1" gutterBottom>
            Welcome to <strong>www.priyabeads.com</strong>. By accessing or using this Website, you
            agree to be bound by these Terms and Conditions. If you do not agree, please do not use
            our Website.
          </Typography>
        </Box>

        {/* 1. Use of the Website */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            1. Use of the Website
          </Typography>
          <Typography
            variant="body1"
            component="ul"
            sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
          >
            <li>
              You must be at least 18 years old or have parental/guardian consent to use this
              Website.
            </li>
            <li>
              You agree to use the Website only for lawful purposes and in a way that does not
              violate any applicable laws or regulations.
            </li>
          </Typography>
        </Box>

        {/* 2. Intellectual Property */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            2. Intellectual Property
          </Typography>
          <Typography
            variant="body1"
            component="ul"
            sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
          >
            <li>
              All content, logos, designs, images, and text on this Website are owned by or licensed
              to <strong>www.priyabeads.com</strong>.
            </li>
            <li>You may not reproduce, distribute, or use any material without prior written permission.</li>
            <li>
              use of any <strong>priyabeads.com</strong> trademark or service mark without{" "}
              <strong>priyabeads.com</strong>&nbsp;'s permission is strictly prohibited.
            </li>
            <li>
              You may not use any of the <strong>priyabeads.com</strong> trademarks or service marks
              in meta tags without the prior explicit consent of <strong>priyabeads.com</strong>.
            </li>
          </Typography>
        </Box>

        {/* 3. User Accounts */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            3. User Accounts
          </Typography>
          <Typography
            variant="body1"
            component="ul"
            sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
          >
            <li>
              If you create an account, we are responsible for maintaining its security and
              confidentiality.
            </li>
            <li>You agree to provide accurate and up-to-date information.</li>
          </Typography>
        </Box>

        {/* 4. Purchases and Payments */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            4. Purchases and Payments
          </Typography>
          <Typography
            variant="body1"
            component="ul"
            sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
          >
            <li>
              All purchases made through the Website are subject to our pricing and availability
            </li>
            <li>We reserve the right to refuse or cancel any order.</li>
            <li>
              We will contact you if all or any portion of your order is cancelled or if additional
              information is required to accept your order.
            </li>
            <li>
              In the event that an item is listed at an incorrect price or with incorrect
              information due to an error in pricing or product information,{" "}
              <strong>priyabeads.com</strong> shall have the right, at our sole discretion, to
              refuse or cancel any orders placed for that item
            </li>
          </Typography>
        </Box>

        {/* 5. Third-Party Links */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            5. Third-Party Links
          </Typography>
          <Typography variant="body1">
            Our Website may contain links to external websites. We are not responsible for the
            content, policies, or practices of third-party websites.
          </Typography>
        </Box>

        {/* 6. Termination */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            6. Termination
          </Typography>
          <Typography variant="body1">
            We reserve the right to suspend or terminate your access to the Website if you violate
            these Terms.
          </Typography>
        </Box>

        {/* 7. Changes to Terms */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            7. Changes to Terms
          </Typography>
          <Typography variant="body1">
            We may update these Terms from time to time. Any changes will be effective immediately
            upon posting on this page.
          </Typography>
        </Box>

        {/* 8. Governing Law */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            8. Governing Law
          </Typography>
          <Typography variant="body1">
            These Terms are governed by the laws of India. Any disputes will be subject to the
            exclusive jurisdiction of the court in Varanasi.
          </Typography>
        </Box>

        {/* 9. Contact Us */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            9. Contact Us
          </Typography>
          <Typography variant="body1" gutterBottom>
            If you have any questions about these Terms, please contact us at:
          </Typography>
          <Typography variant="body1" gutterBottom>
            Email:{" "}
            <a href="mailto:contact@priyabeads.com">contact@priyabeads.com</a>
          </Typography>
          <Typography variant="body1">Phone: +91 7233034085</Typography>
        </Box>

        {/* Shipping Settings */}
        <Box>
            <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
            Shipping Settings
          </Typography>

          {/* 1. Shipping Coverage */}
          <Box sx={{ mt: 1 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              1. Shipping Coverage
            </Typography>
            <Typography variant="body1">
              We currently ship orders within all over India.
            </Typography>
          </Box>

          {/* 2. Processing Time */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              2. Processing Time
            </Typography>
            <Typography
              variant="body1"
              component="ul"
              sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
            >
              <li>Orders are processed within 2-Days after payment confirmation.</li>
              <li>Orders placed on weekends or holidays will be processed on the next business day.</li>
            </Typography>
          </Box>

          {/* 3. Shipping Methods & Rates */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              3. Shipping Methods & Rates
            </Typography>
            <Typography
              variant="body1"
              component="ul"
              sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
            >
              <li>Standard Shipping: Delivered within 5–7 days.</li>
              <li>Express Shipping: Delivered within 3–4 days, additional charges apply.</li>
              <li>Free Shipping: Available on orders above ₹999 amount (standard delivery only).</li>
            </Typography>
          </Box>

          {/* 4. Delivery Time */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              4. Delivery Time
            </Typography>
            <Typography variant="body1" gutterBottom>
              Delivery times are estimates and may vary due to courier delays, weather, or other
              unforeseen circumstances. Customers will receive a tracking number once the order has
              been shipped.
            </Typography>
            <Typography
              variant="body1"
              component="ul"
              sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
            >
              <li>
                Southern Zone: Like Andhra Pradesh, Tamil Nadu, Karnataka, Kerela (Transit time
                about 5 days to 7 days)
              </li>
              <li>
                North East Zone: Like West Bengal, Assam, Odisha (Transit time about 8 days to 10
                days)
              </li>
              <li>
                Western Zone: Like Maharashtra (Mumbai, Pune, Nasik), Gujarat, Goa (Transit time
                about 5–7 days)
              </li>
              <li>
                North Zone: Like Delhi, Punjab, U.P (Transit time about 3–5 days)
              </li>
            </Typography>
          </Box>

          {/* 5. Order Tracking */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              5. Order Tracking
            </Typography>
            <Typography variant="body1">
              A tracking link will be provided via email/SMS/Whatsapp message on registered mobile
              number once your package is dispatched. You can also check your order status directly
              on our website under <strong>My Orders</strong>.
            </Typography>
          </Box>

          {/* 6. Address & Delivery Issues */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              6. Address & Delivery Issues
            </Typography>
            <Typography
              variant="body1"
              component="ul"
              sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
            >
              <li>
                Please ensure the shipping address is correct at checkout. We are not responsible
                for delays or lost packages caused by incorrect or incomplete addresses.
              </li>
              <li>
                If a package is returned to us due to incorrect address details, reshipping charges
                will apply.
              </li>
            </Typography>
          </Box>

          {/* 7. Shipping Partners */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              7. Shipping Partners
            </Typography>
            <Typography variant="body1">
              We partner with trusted logistics providers such as [Courier Names, e.g., BlueDart,
              DTDC, Delhivery, Trackon, etc.] for safe and timely delivery.
            </Typography>
          </Box>

          {/* 8. Restrictions */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              8. Restrictions
            </Typography>
            <Typography variant="body1">
              Certain products may not be eligible for shipping to specific locations due to
              customs, regulations, or courier limitations. Customers will be notified if
              restrictions apply.
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Container>
  );
}
